import React from "react";
import { Link } from "react-router-dom";

const FNFTHeader = () => {
  return (
    <header className="header">
      <div className="container">
        <h1 className="header__title">F-NFT Fundraising</h1>
        <nav className="header__nav">
          <Link to="/">Home</Link>
          <Link to="/mint">Mint NFT</Link>
          <Link to="/fractionalize">Fractionalize</Link>
          <Link to="/campaign">Campaign</Link>
        </nav>
      </div>
    </header>
  );
};

export default FNFTHeader;
